/**
 * @generated SignedSource<<d0428c5d9ba98a9c408448264cec8a35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodsQuery$variables = Record<PropertyKey, never>;
export type PaymentMethodsQuery$data = {
  readonly session: {
    readonly user: {
      readonly memberProfiles?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly member: {
              readonly club?: {
                readonly name: string;
              };
              readonly memberCards?: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly " $fragmentSpreads": FragmentRefs<"SelectedPaymentMethodFragment" | "SquareCardFragment">;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly squareCards?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"SelectedPaymentMethodFragment" | "SquareCardFragment">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PaymentMethodsQuery = {
  response: PaymentMethodsQuery$data;
  variables: PaymentMethodsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": true
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SquareCardOnFileEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SquareCardOnFile",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SquareCardFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SelectedPaymentMethodFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SquareCardOnFileEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SquareCardOnFile",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardBrand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastFour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "default",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberPackageConnection",
            "kind": "LinkedField",
            "name": "memberPackages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentMethodsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Club",
                                        "kind": "LinkedField",
                                        "name": "club",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "memberCards",
                                        "args": (v2/*: any*/),
                                        "concreteType": "SquareCardOnFileConnection",
                                        "kind": "LinkedField",
                                        "name": "squareCards",
                                        "plural": false,
                                        "selections": (v3/*: any*/),
                                        "storageKey": "squareCards(enabled:true)"
                                      }
                                    ],
                                    "type": "Customer",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true)"
                  },
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PaymentMethodsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Club",
                                        "kind": "LinkedField",
                                        "name": "club",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "memberCards",
                                        "args": (v2/*: any*/),
                                        "concreteType": "SquareCardOnFileConnection",
                                        "kind": "LinkedField",
                                        "name": "squareCards",
                                        "plural": false,
                                        "selections": (v7/*: any*/),
                                        "storageKey": "squareCards(enabled:true)"
                                      }
                                    ],
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v6/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true)"
                  },
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17a4d22ddc1a8b614f0797bca030a4aa",
    "id": null,
    "metadata": {},
    "name": "PaymentMethodsQuery",
    "operationKind": "query",
    "text": "query PaymentMethodsQuery {\n  session {\n    user {\n      __typename\n      ... on MemberUser {\n        memberProfiles(active: true) {\n          edges {\n            node {\n              member {\n                __typename\n                ... on Customer {\n                  club {\n                    name\n                    id\n                  }\n                  memberCards: squareCards(enabled: true) {\n                    edges {\n                      node {\n                        ...SquareCardFragment\n                        ...SelectedPaymentMethodFragment\n                        id\n                      }\n                    }\n                  }\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n        squareCards(enabled: true) {\n          edges {\n            node {\n              ...SquareCardFragment\n              ...SelectedPaymentMethodFragment\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment SelectedPaymentMethodFragment on SquareCardOnFile {\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n  user {\n    id\n  }\n  memberPackages {\n    count\n  }\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n"
  }
};
})();

(node as any).hash = "420abaf24b0c4700a2f36be4d03aa96e";

export default node;
